<template>
  <div>
    <div v-if="lists && lists.length > 0">
      <el-table
                :data="lists" stripe border
                style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="p">
            <div v-if="p.row.invoiceDetilList">
              <h4>开票内容</h4>
              <p v-for="(item,idx) in p.row.invoiceDetilList">{{idx+1}}.{{item.bussinessName}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="开票项" prop="project" width="120" sortable>
        </el-table-column>
        <el-table-column
          prop="company" label="抬头" width="220" sortable>
        </el-table-column>
        <el-table-column
          prop="invoiceNum" label="发票号" width="220" sortable>
        </el-table-column>
        <el-table-column
          prop="invoiceFee" label="开票金额(￥)" width="180" sortable>
        </el-table-column>
        <el-table-column label="开票时间" width="220" sortable>
          <template slot-scope="p">
            {{invoiceDateFormat(p.row.invoiceDate)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="taxNo" label="纳税人号" width="180" sortable>
        </el-table-column>
        <el-table-column
          prop="taxRate" label="税率" width="80">
        </el-table-column>
        <el-table-column
          prop="invoiceFlagName" label="状态" fixed="right" sortable>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="p">
            <el-button size="mini" type="primary" @click="getInvoice(p.row.id)">获取发票</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <h5 class="none_ts" v-if="lists.length == '0'">
      <img src="@/assets/images/none_data.jpg" alt="">
      <h4>暂无记录</h4>
    </h5>
    <!--<div class="zy_list_bottom">
      <dl>
        <dt v-if="lists.length > 0">共{{cnt}}条记录</dt>
        <dd v-if="lists.length >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>-->
  </div>
</template>
<script>
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        pages: 0,
        cnt: 0,
        filters: {
          pageNo: 1,
          pageSize: 9,
          delFlag: '0',
          inBatchNo: '1'
        }
      }
    },
    created () {
      this.getLists(this.filters).then((r) => {
        this.cnt = r.cntData
        if (r.data) {
          this.lists = r.data
          this.pages = Math.ceil(this.cnt / this.filters.pageSize)
        } else {
          this.lists = []
          this.pages = 0
        }
      })
    },
    methods: {
      invoiceDateFormat: utils.invoiceDateFormat,
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.getLists(this.filters)
      },
      getLists (filter) {
        return new Promise((resolve, reject) => {
          this.$api.post(this.$global.paymentApiPath, '/invoice/findList', filter, r => {
            resolve(r)
          })
        })
      },
      getInvoice (b_id) { // 获取发票
        this.$api.get(this.$global.paymentApiPath, '/invoice/getInvoiceAddress', {invoiceId: b_id}, r => {
          const a = document.createElement('a'); // 创建a标签
          a.setAttribute('download', '');// download属性
          a.setAttribute('href', r.data);// href链接
          a.setAttribute('target', '_blank'); // 打开新窗口
          a.click();// 自执行点击事件
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/invoice.vue